import MyOrdersPage from './MyOrdersPage';

export default MyOrdersPage;